import type { FC } from "react";

export interface BarGraphBarProps {
  value: number; // Number between 0 and 1 as a percentage
  style: "green" | "amber" | "red" | "default";
  size: "h-2" | "h-3" | "h-4";
}

export const BarGraphBar: FC<BarGraphBarProps> = (props) => {
  const style = {
    green: "bg-green-600",
    amber: "bg-amber-600",
    red: "bg-red-600",
    default: "bg-brand-600",
  }[props.style ?? "default"];
  return (
    <div className={`w-full ${props.size} relative bg-slate-300 rounded-full mt-2`}>
      <div
        className={`absolute top-0 left-0 ${props.size} rounded-full ${style}`}
        style={{ width: `${props.value * 100}%` }}
      ></div>
    </div>
  );
};
